import React from 'react'
import { connect } from 'react-redux'
import CouponActions from '../../Redux/CouponRedux'
import Modal from 'react-responsive-modal'
import moment from 'moment'
import FormatMoney from '../../Utils/FormatMoney'

class ViewAffiliateHistory extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {},
      form: {
        user_id: props.detail.user_redeem_histories.user_id,
        transfer_amount: undefined
      }
    }
  }

  _selectItem = (modalID, item) => {
    if (modalID === 'modal-input-transfer-amount') {
      this.setState({
        detail: item,
        form: {
          transfer_amount: item.point
        }
      })
    } else {
      this.setState({
        detail: item
      })
    }
    this._toggleModal(modalID)
  }

  _toggleModal = (modalID = null) => {
    if (!modalID) {
      this.setState({
        detail: {}
      })
    }
    this.setState({ showModal: modalID })
  }

  _inputChange = (event, field) => {
    const value = event.target.value
    let form = { ...this.state.form }
    form[field] = value
    this.setState({ form })
  }

  _submit = (event, UUID, USER_ID) => {
    event.preventDefault()
    let form = { ...this.state.form }
    let uuid = UUID
    form.user_id = USER_ID
    let data = {
      form,
      uuid
    }
    setTimeout(() => {
      this.props.affiliateTransfer(data)
    }, 500)
    this.props.closeModal()
  }

  render () {
    const { detail } = this.props
    const { user_redeem_histories, coupon_affiliates } = detail
    return (
      <section className='section' style={{ width: '55vw' }}>
        <div className='title-block'>
          <h1 className='title'>Redemption Details</h1>
        </div>
        {
          coupon_affiliates !== null &&
          <div className='title-block'>
            <h1 className='title'>Affiliate Details</h1>
          </div>
        }
        {
          coupon_affiliates !== null &&
          <table className='table table-hover table-striped'>
            <tbody>
              <tr>
                <td><strong>User Name</strong></td>
                <td>{ coupon_affiliates.name || '- No Data -' }</td>
              </tr>
              <tr>
                <td><strong>Bank Name</strong></td>
                <td>{ coupon_affiliates.bank_name || '- No Data -' }</td>
              </tr>
              <tr>
                <td><strong>Bank Account Number</strong></td>
                <td>{ coupon_affiliates.rekening || '- No Data -' }</td>
              </tr>
              <tr>
                <td><strong>Taxpayer Number (NPWP)</strong></td>
                <td>{ coupon_affiliates.npwp || '- No Data -' }</td>
              </tr>
              <tr>
                <td><strong>View Coupon Usage History</strong></td>
                <td>{ coupon_affiliates.coupon_histories && <button onClick={() => this._selectItem('modal-coupon-histories', coupon_affiliates.coupon_histories)} className='btn btn-primary'>Click to View</button>}</td>
              </tr>
            </tbody>
          </table>
        }
        <div className='title-block'>
          <h1 className='title'>Redemption History</h1>
        </div>
        <table className='table table-hover table-striped'>
          <thead>
            <tr>
              <th>Point</th>
              <th>Status</th>
              <th>Create Date</th>
              <th className='text-center'>Transfer</th>
            </tr>
          </thead>
          <tbody>
            {
              user_redeem_histories &&
              user_redeem_histories.length > 0
                ? user_redeem_histories.map((item, i) => (
                  <tr key={i}>
                    <td>{item.point}</td>
                    <td>
                      {item.status === 'redeem' && <p>Redeemed <i className='fa fa-check-circle' /></p>}
                      {item.status === 'paid' && <p>Paid <i className='fa fa-check-circle' /></p>}
                      {item.status === 'process' && <p>Processing</p>}
                    </td>
                    <td>{moment(item.created_at).format('DD MMM YYYY, h:mm:ss a')}</td>
                    <td className='text-center'>
                      {
                        item.status === 'process'
                          ? <div>
                            <button className='btn btn-primary' onClick={() => this._selectItem('modal-input-transfer-amount', item)}>Input Transfer Amount</button>
                          </div>
                          : null
                      }
                    </td>
                  </tr>
                ))
                : <tr>
                  <td className='text-center' colSpan='4'>- No Data -</td>
                </tr>
            }
          </tbody>
        </table>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-coupon-histories'} onClose={this._toggleModal}>
          <section className='section' style={{ width: '90vw' }}>
            <div className='title-block'>
              <h1 className='title'>Coupon Usage History</h1>
            </div>
            <table className='table table-bordered table-striped'>
              <thead>
                <tr>
                  <th className='text-center'>Order ID</th>
                  <th className='text-center'>User Name</th>
                  <th className='text-center'>Use Date</th>
                  <th className='text-center'>Final Amount</th>
                  <th className='text-center'>User Destination</th>
                  <th className='text-center'>Transfer Request</th>
                  <th className='text-center'>Transfer Date</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.state.detail &&
                  this.state.detail.length > 0
                    ? this.state.detail.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center align-middle'>{item.order.order_number}</td>
                        <td className='text-center align-middle'>{item.user.first_name} {item.user.last_name}</td>
                        <td className='text-center align-middle'>{moment.unix(item.order.created_at).format('DD/MM/YYYY')}</td>
                        <td className='text-center align-middle'>{FormatMoney(item.order.final_amount)}</td>
                        <td className='text-center align-middle'>{item.order.user_destination && item.order.user_destination.length > 0 ? item.order.user_destination.toString() : '-'}</td>
                        <td className='text-center align-middle'>{item.order.user_redeem_order_history.length > 0 ? <i className='fa fa-check' /> : <i className='fa fa-times' />}</td>
                        <td className='text-center align-middle'>
                          {
                            item.order.user_redeem_order_history.length > 0
                              ? item.order.user_redeem_order_history[0].transfer_status && item.order.user_redeem_order_history[0].transfer_date
                              : '- No transfer request yet -'
                          }
                        </td>
                      </tr>
                    ))
                    : <tr>
                      <td className='text-center' colSpan='6'>- No Usage Data -</td>
                    </tr>
                }
              </tbody>
            </table>
            <div className='row'>
              <div className='col-12 text-right'>
                <button type='button' onClick={this._toggleModal} className='btn btn-primary'>Close</button>
              </div>
            </div>
          </section>
        </Modal>

        <Modal classNames={{ modal: 'modal-large' }} center open={this.state.showModal === 'modal-input-transfer-amount'} onClose={this._toggleModal}>
          <section className='section' style={{ width: '50vw' }}>
            <div className='title-block'>
              <h1 className='title'>Submit transfer amount</h1>
            </div>
            <div>
              <form onSubmit={(event) => this._submit(event, this.state.detail.id, this.state.detail.user_id)}>
                <div className='form-group'>
                  <div className='row'>
                    <div className='col-3'>
                      <label className='control-label'>Transfer Amount</label>
                    </div>
                    <div className='col-9'>
                      <input type='number' min={1} className='form-control' value={this.state.form.transfer_amount} onChange={(event) => this._inputChange(event, 'transfer_amount')} />
                    </div>
                  </div>
                </div>
                <div className='text-right'>
                  <button type='button' className='btn btn-secondary mr-2' onClick={this._toggleModal}>Close</button>
                  <button type='submit' className='btn btn-primary'>Submit</button>
                </div>
              </form>
            </div>
          </section>
        </Modal>

        <div className='text-right'>
          <button className='btn btn-lg btn-primary' onClick={() => this.props.closeModal()}>Close</button>
        </div>
      </section>
    )
  }
}

const stateToProps = (state) => ({})

const dispatchToProps = (dispatch) => ({
  affiliateTransfer: (data) => dispatch(CouponActions.affiliateTransferRequest(data))
})

export default connect(stateToProps, dispatchToProps)(ViewAffiliateHistory)



// WEBPACK FOOTER //
// ./src/Containers/Coupon/ViewAffiliateHistory.js